const increaseDecreaseScrollSpeed = (type, setSeekSpeed) => {
  type === "Up"
    ? setSeekSpeed((pre) => (parseFloat(pre) != 1.811 ? pre + 0.01 : 1.81))
    : setSeekSpeed((pre) => (pre != 0.81 ? pre - 0.01 : 0.81));
};

export { increaseDecreaseScrollSpeed };
